import { atom } from "jotai";
import type { IMapRequest } from "types/maps/request";

/**
 * Well Map Request Atom
 *
 * Stores the current map request configuration for wells.
 * This atom can be used to track and manage well map requests
 * independently of Redux state.
 */

/**
 * Initial/empty well map request
 */
export const EMPTY_WELL_MAP_REQUEST: Maybe<IMapRequest> = null;

/**
 * Base atom for well map request
 * Stores the current IMapRequest for wells
 */
export const wellMapRequestAtom = atom<Maybe<IMapRequest>>(EMPTY_WELL_MAP_REQUEST);
